export default [{
    path: 'person',
    component: () => import('@/views/organization/person/person'),
}]